import React, {
  useState,
  useEffect,
} from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import DatePickerReports from '../../components/DatePickerReports'

import useFetchAll from '../../hooks/useFetchAll'

import MainHeader from '../../components/MainHeader'
import MainView from '../../components/MainView'
import EmployeeDetails from '../../components/EmployeeDetails'
import EmployeeJobList from '../../components/EmployeeJobList'

import {
  fetchAllEmployees,
  deleteEmployee,
} from '../../store/actions'

import './index.css'
import DeleteEmployeeModal from './DeleteEmployeeModal'
import ChangePasswordModal from './ChangePasswordModal'

const EmployeeInfo = (props) => {
  useFetchAll({ condition: !props.employeeList.length, action: props.fetchAllEmployees })
  const [ employee, setEmployee ] = useState(null)
  const [ isShowDeleteEmployeeModal, setIsShowDeleteEmployeeModal ] = useState(false)
  const [ isShowChangePasswordModal, setIsShowChangePasswordModal ] = useState(false)
  const [ showDatePickerEmployeesReports, setShowDatePickerEmployeesReports ] = useState(false)


  useEffect(() => {
    if (!props.employeeList.length) {
      return
    }
    const employee = [ ...props.employeeList,
      ...props.searchedEmployeeList ].find(employee => props.match.params.employeeId === employee.UUID)
    setEmployee(employee)
  }, [ props.employeeList ])

  const toggleDeleteEmployeeModal = () => {
    setIsShowDeleteEmployeeModal(!isShowDeleteEmployeeModal)
  }

  const toggleChangePasswordModal = () => {
    setIsShowChangePasswordModal(!isShowChangePasswordModal)
  }

  const toggleDatePickerEmployeesReports = () => {
    setShowDatePickerEmployeesReports(!showDatePickerEmployeesReports)
  }

  const onDelete = async () => {
    props.deleteEmployee(employee, () => props.history.push('/employees'))
  }

  return (
    <div>
      <MainHeader title={employee ? employee.firstName + ' ' + employee.lastName : ''} backLink="/employees" />
      <MainView>
        {employee &&
         <div className="employee-info">
           <div className="employee-info__left-bar">
             <EmployeeDetails
               employee={employee}
               onDeleteEmployee={toggleDeleteEmployeeModal}
               onChangePassword={toggleChangePasswordModal}
             />
           </div>
           <div className="employee-info__right-bar">
             <EmployeeJobList employee={employee} />
           </div>
         </div>
        }
      </MainView>
      {isShowDeleteEmployeeModal &&
       <DeleteEmployeeModal
         onClose={toggleDeleteEmployeeModal}
         title={employee.firstName + ' ' + employee.lastName}
         onDelete={onDelete}
       />}
      {isShowChangePasswordModal &&
       <ChangePasswordModal
         onClose={toggleChangePasswordModal}
         title="Password"
         employee={employee}
       />}
      {
        showDatePickerEmployeesReports &&
        <DatePickerReports toggleModal={toggleDatePickerEmployeesReports}/>
      }
    </div>
  )
}

const mapStateToProps = ({
                           employees:
                             {
                               employeeList,
                               employeeSearch: {
                                 searchedEmployeeList,
                               },
                             },
                         }) => ({
  employeeList,
  searchedEmployeeList,
})

export default connect(mapStateToProps, { fetchAllEmployees, deleteEmployee })(withRouter(EmployeeInfo))
